"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Select = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _lodash = _interopRequireDefault(require("lodash"));
var _icon = _interopRequireDefault(require("../../icon"));
var _scrollbar = require("../../scrollbar");
var _utilities = require("../../utilities");
var _selectModule = _interopRequireDefault(require("./select.module.scss"));
require("../../style/animations.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Select = exports.Select = /*#__PURE__*/function (_Component) {
  function Select() {
    var _this;
    _classCallCheck(this, Select);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Select, [].concat(args));
    _defineProperty(_this, "portalRoot", void 0);
    _defineProperty(_this, "window", window);
    _defineProperty(_this, "document", document);
    _defineProperty(_this, "select", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "nodeRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "optionsRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "optionMaxHeight", 200);
    _defineProperty(_this, "state", {
      visible: false,
      hidden: true,
      hover: null,
      width: _this.props.width || "auto",
      optionPosition: {
        top: "auto",
        left: "auto",
        width: "auto"
      }
    });
    _defineProperty(_this, "isMobileDevice", _utilities.utilities.device.isMobileDevice);
    _defineProperty(_this, "element", document.createElement("div"));
    _defineProperty(_this, "setOptionMaxHeight", function () {
      _this.optionMaxHeight = _this.props.optionMaxHeight;

      /** Use the device viewport height for the max height instead of any provided value. */
      if (_this.isMobileDevice()) {
        _this.optionMaxHeight = _this.document.documentElement.clientHeight * 0.8;
      }
    });
    _defineProperty(_this, "handleClickOutside", function (event) {
      var _this$select, _this$optionsRef, _event$target;
      /* istanbul ignore else */
      if ((_this$select = _this.select) !== null && _this$select !== void 0 && _this$select.current && !_this.select.current.contains(event.target) && (_this$optionsRef = _this.optionsRef) !== null && _this$optionsRef !== void 0 && _this$optionsRef.current && !_this.optionsRef.current.contains(event.target) && ((_event$target = event.target) === null || _event$target === void 0 || (_event$target = _event$target.attributes["data-testid"]) === null || _event$target === void 0 ? void 0 : _event$target.value) !== "scrollbarView" && _this.state.visible) {
        _this.setVisible();
        _this.props.onClose && _this.props.onClose();
      }
    });
    _defineProperty(_this, "showOptions", function () {
      if (!_this.props.disabled) {
        if (_this.state.visible) {
          _this.setVisible();
        } else {
          _this.setOptionsPosition(true);
          _this.props.onOpen && _this.props.onOpen();
        }
      }
    });
    _defineProperty(_this, "setOptionsPosition", function () {
      var setVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var selectPosition = _this.select.current.getBoundingClientRect();
      _this.setState({
        optionPosition: {
          top: selectPosition.top + selectPosition.height,
          left: selectPosition.left,
          width: selectPosition.width
        }
      }, setVisible ? _this.setVisible : null);
    });
    _defineProperty(_this, "setPosition", function () {
      if (_this.state.visible) {
        _this.setOptionsPosition();
      }
    });
    _defineProperty(_this, "hideOptions", function () {
      /* istanbul ignore else */
      if (_this.state.visible) {
        _this.setHidden();
        _this.setVisible();
      }
    });
    _defineProperty(_this, "optionSelect", function (e) {
      var value = _this.getValueFromOptionElement(e.target);

      /* istanbul ignore else */
      if (value !== _this.props.selected) {
        _this.props.selectOption && _this.props.selectOption(value);
      }
      _this.hideOptions();
    });
    _defineProperty(_this, "optionMouseOver", function (e) {
      var target = e.target;
      var value = target.getAttribute("data-value");

      /* istanbul ignore else */
      if (_this.state.hover !== value) {
        _this.setState({
          hover: value
        });
      }
    });
    _defineProperty(_this, "optionMouseOut", function () {
      /* istanbul ignore else */
      if (_this.state.hover !== _this.props.selected) {
        _this.setState({
          hover: _this.props.selected
        });
      }
    });
    _defineProperty(_this, "setVisible", function () {
      if (_this.isMobileDevice() && !_this.state.visible) {
        //stop body from scrolling when options are open on mobile
        _this.document.body.style.overflow = "hidden";
      } else {
        _this.document.body.style.overflow = "auto";
      }
      _this.setState({
        visible: !_this.state.visible
      });
    });
    _defineProperty(_this, "getChild", function (child, key) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: key,
        "data-value": child.props.value,
        "data-testid": _this.getDataTestId(child),
        className: _this.getOptionStyle(child),
        onMouseEnter: _this.optionMouseOver,
        onMouseLeave: _this.optionMouseOut,
        onClick: _this.optionSelect
      }, child);
    });
    _defineProperty(_this, "setHidden", function () {
      _this.setState({
        hidden: true
      });
    });
    _defineProperty(_this, "unsetHidden", function () {
      _this.setState({
        hidden: false
      });
    });
    return _this;
  }
  _inherits(Select, _Component);
  return _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mousedown", this.handleClickOutside);
      this.window.addEventListener("scroll", this.setPosition, true);
      this.window.addEventListener("resize", this.setPosition, true);
      this.window.addEventListener("resize", _lodash["default"].debounce(this.setOptionMaxHeight, 500));
      if (!document.getElementById("select-portal-div")) {
        this.portalRoot = document.createElement("div");
        this.portalRoot.id = "select-portal-div";
        document.body.appendChild(this.portalRoot);
      } else {
        this.portalRoot = document.getElementById("select-portal-div");
      }
      this.portalRoot.appendChild(this.element);
      this.setCurrentHover();
      this.setOptionMaxHeight();
      this.setSelectWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
      window.removeEventListener("scroll", this.setPosition);
      window.removeEventListener("resize", this.setPosition);
      this.portalRoot.removeChild(this.element);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.selected !== prevProps.selected) {
        this.setCurrentHover();
      }
      this.setOptionMaxHeight();
      this.setSelectWidth();
    }
  }, {
    key: "setCurrentHover",
    value: function setCurrentHover() {
      if (this.props.selected) {
        this.setState({
          hover: this.props.selected
        });
      }
    }
  }, {
    key: "setSelectWidth",
    value: function setSelectWidth() {
      if (!this.props.width && !this.isMobileDevice()) {
        var box = this.nodeRef.current.getBoundingClientRect();
        var newWidth = box.width;
        if (this.state.width === "auto") {
          newWidth = box.width + 40; //for chevron icon
        }
        if (newWidth && (newWidth > this.state.width || this.state.width === "auto")) {
          this.setState({
            width: newWidth
          });
        }
      }
    }
  }, {
    key: "getValueFromOptionElement",
    value: function getValueFromOptionElement(target) {
      var value = target.getAttribute("value");
      var option = target.closest('[data-testid="option"]');
      if (option) {
        if (option.hasAttribute("data-value")) {
          value = option.getAttribute("data-value");
        }
        if (option.hasAttribute("value")) {
          value = option.getAttribute("value");
        }
      }
      return value;
    }
  }, {
    key: "getMobileStyles",
    value: function getMobileStyles(state) {
      var defaultStyle = {
        transition: "opacity 300ms ease-in-out",
        pointerEvents: "none",
        opacity: 0
      };
      var transitionStyles = {
        entering: {
          opacity: 1,
          pointerEvents: "auto"
        },
        entered: {
          opacity: 1,
          pointerEvents: "auto"
        },
        exiting: {
          opacity: 0,
          pointerEvents: "none"
        },
        exited: {
          opacity: 0,
          pointerEvents: "none"
        }
      };
      var margin = "auto";
      if (this.optionsRef && this.optionsRef.current) {
        var _this$optionsRef$curr = this.optionsRef.current.getBoundingClientRect(),
          height = _this$optionsRef$curr.height;
        /** Limit the height we use for margin calc to be 80% of the window height */
        height = Math.min(height, this.window.innerHeight * 0.8);
        margin = (this.window.innerHeight - height).toFixed(0) / 2;
      }
      return _objectSpread(_objectSpread(_objectSpread({}, defaultStyle), transitionStyles[state]), {}, {
        marginTop: margin,
        marginBottom: margin
      });
    }
  }, {
    key: "getDesktopStyles",
    value: function getDesktopStyles(state) {
      var defaultStyle = {
        transition: "max-height 300ms ease-in-out",
        maxHeight: 0,
        opacity: 0
      };
      var transitionStyles = {
        entering: {
          maxHeight: this.optionMaxHeight,
          opacity: 1,
          pointerEvents: "none"
        },
        entered: {
          maxHeight: this.optionMaxHeight,
          opacity: 1
        },
        exiting: {
          maxHeight: 0,
          opacity: 1,
          pointerEvents: "none"
        },
        exited: {
          maxHeight: 0,
          opacity: 0,
          pointerEvents: "none"
        }
      };
      return _objectSpread(_objectSpread(_objectSpread({}, defaultStyle), transitionStyles[state]), {}, {
        width: this.state.optionPosition.width,
        top: this.state.optionPosition.top,
        left: this.state.optionPosition.left
      });
    }
  }, {
    key: "getStyles",
    value: function getStyles(state) {
      if (this.isMobileDevice()) {
        return this.getMobileStyles(state);
      } else {
        return this.getDesktopStyles(state);
      }
    }
  }, {
    key: "getOptionStyle",
    value: function getOptionStyle(option) {
      return "".concat(_selectModule["default"].option, " ").concat(String(option.props.value) === String(this.state.hover) && _selectModule["default"].selected);
    }
  }, {
    key: "getSelectStyle",
    value: function getSelectStyle() {
      return "".concat(_selectModule["default"].select, " ").concat(this.state.hidden && _selectModule["default"].hidden, " ").concat(this.props.size === "small" && _selectModule["default"].small);
    }
  }, {
    key: "getActiveStyle",
    value: function getActiveStyle() {
      return "".concat(_selectModule["default"].active, " ").concat(this.state.visible && _selectModule["default"].visible, " ").concat(this.props.disabled && _selectModule["default"].disabled);
    }
  }, {
    key: "getOptionsContainerStyle",
    value: function getOptionsContainerStyle() {
      return "".concat(_selectModule["default"].optionContainer, " ").concat(this.isMobileDevice() && _selectModule["default"].mobile, " ").concat(this.props.size === "small" && !this.isMobileDevice() && _selectModule["default"].small);
    }
  }, {
    key: "getDataTestId",
    value: function getDataTestId(option) {
      return "".concat(String(option.props.value) === String(this.props.selected) ? "selected-option" : "option");
    }
  }, {
    key: "getSelected",
    value: function getSelected() {
      var _this2 = this;
      var selected = "\xA0";
      if (this.props.children) {
        this.props.children.forEach(function (element) {
          /* istanbul ignore else */
          if (element.props.value === _this2.props.selected) {
            selected = element.props.children;
          }
        });
      }
      return selected;
    }
  }, {
    key: "renderActive",
    value: function renderActive() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "selected",
        className: this.getActiveStyle(),
        onClick: this.showOptions
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _selectModule["default"].string
      }, this.getSelected()), /*#__PURE__*/_react["default"].createElement("div", {
        className: _selectModule["default"].chevron
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        type: "ChevronDown"
      })));
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      return _react["default"].Children.map(this.props.children, this.getChild);
    }
  }, {
    key: "getContainerDataId",
    value: function getContainerDataId(state) {
      return state === "entered" ? "select-options" : "";
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        "data-testid": "select"
      }, _utilities.utilities.getDataAttributes(this.props), {
        "data-selected": this.props.selected,
        className: this.getSelectStyle(),
        ref: this.select,
        style: _objectSpread(_objectSpread({}, this.props.style), {}, {
          width: this.state.width
        })
      }), this.renderActive(), /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
        "in": this.state.visible,
        timeout: 300,
        nodeRef: this.nodeRef,
        onEnter: this.unsetHidden,
        onExited: this.setHidden
      }, function (state) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: _this3.nodeRef,
          className: _this3.getOptionsContainerStyle(),
          "data-testid": _this3.getContainerDataId(state),
          style: _objectSpread({}, _this3.getStyles(state))
        }, /*#__PURE__*/_react["default"].createElement(_scrollbar.ShadowScrollbars, {
          autoHeight: true,
          fireWindowScrollEvents: false,
          autoHeightMax: _this3.optionMaxHeight,
          trackBackground: true
        }, /*#__PURE__*/_react["default"].createElement("div", {
          ref: _this3.optionsRef
        }, _this3.renderOptions())));
      }), this.element));
    }
  }]);
}(_react.Component);
Select.propTypes = {
  selected: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  selectOption: _propTypes["default"].func,
  size: _propTypes["default"].oneOf(["normal", "small"]),
  optionMaxHeight: _propTypes["default"].number,
  style: _propTypes["default"].object,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  disabled: _propTypes["default"].bool
};
Select.defaultProps = {
  selected: null,
  size: "normal",
  disabled: false,
  optionMaxHeight: 200
};
var _default = exports["default"] = Select;